module.exports = __webpack_public_path__ + "static/media/icon-info.87957fc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/add-to-cart-section/icon-info.svg
// module id = 898
// module chunks = 1